import { useRef } from "react";

// Drawing with letter+input boxes positioned in % (x,y). In edit mode boxes are draggable.
export default function DimDrawing({ config, values = {}, onChange, editable = false, onMove }) {
    const ref = useRef(null);
    const fields = (config.fields || []).filter((f) => f.on_drawing !== false);

    const startDrag = (e, key) => {
        if (!editable) return;
        e.preventDefault();
        const move = (ev) => {
            const rect = ref.current.getBoundingClientRect();
            const x = ((ev.clientX - rect.left) / rect.width) * 100;
            const y = ((ev.clientY - rect.top) / rect.height) * 100;
            onMove(key, Math.max(-20, Math.min(120, +x.toFixed(2))), Math.max(-20, Math.min(120, +y.toFixed(2))));
        };
        const up = () => {
            window.removeEventListener("pointermove", move);
            window.removeEventListener("pointerup", up);
        };
        window.addEventListener("pointermove", move);
        window.addEventListener("pointerup", up);
    };

    return (
        <div ref={ref} className="relative w-full select-none" data-testid="dim-drawing">
            {config.image_url ? (
                <img src={config.image_url} alt="drawing" className="w-full h-auto pointer-events-none" draggable={false} />
            ) : (
                <div className="aspect-[16/9] grid place-items-center text-xs font-mono text-slate-400 border border-dashed border-slate-300">No drawing</div>
            )}
            {fields.map((f) => (
                <label
                    key={f.key}
                    onPointerDown={(e) => startDrag(e, f.key)}
                    className={`absolute flex items-center gap-1 bg-white/95 border px-1.5 py-0.5 shadow-sm rounded-md ${
                        editable ? "cursor-move border-[hsl(var(--primary))] ring-2 ring-[hsl(var(--primary)/0.25)]" : "border-slate-300"
                    }`}
                    style={{ left: `${f.x}%`, top: `${f.y}%`, transform: f.rotate ? `rotate(${f.rotate}deg)` : undefined, transformOrigin: "left top" }}
                    data-testid={`dim-drawing-field-${f.key}`}
                >
                    <span className="font-display font-black text-sm text-slate-900">{f.key}</span>
                    <input
                        type="text"
                        inputMode="decimal"
                        placeholder="mm"
                        disabled={editable}
                        value={values[f.key] || ""}
                        onChange={(e) => onChange?.(f.key, e.target.value)}
                        className="w-12 text-xs font-mono bg-transparent outline-none text-slate-900 placeholder:text-slate-400"
                        data-testid={`dim-drawing-input-${f.key}`}
                    />
                </label>
            ))}
        </div>
    );
}
